import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Hr, Icon } from 'ui';
import useButtonSplit from './useButtonSplit';

const ButtonSplit = ({ onClick = () => {}, onChange = () => {}, selected = 0, options = [{ text: 'Envía algo!' }], disabled = false }) => {
  const { t } = useTranslation(['buttons']);
  const { anchorRef, chevronRef, chevronId, menuId, open, optionsWithKeys, selectedIndex, handleMenuItemClick, handleToggle, handleClose, handleListKeyDown } = useButtonSplit({
    onChange,
    options,
    selected,
  });

  return (
    <div className={`button-split ${disabled ? 'button-split--disabled' : ''}`}>
      {/* <fieldset> aporta el rol `group` de forma nativa (SonarQube S6819 prefiere
          el tag sobre role="group"). No se le pasa el atributo `disabled`, así que
          no hay cascada a los Button: cada uno gestiona su propio `isDisabled`. */}
      <fieldset className="button-split__container-buttons" ref={anchorRef} aria-label={t('buttons:Split button actions')}>
        <div className="button-split__button-main">
          <Button
            isDisabled={disabled}
            onClick={onClick}
            text={options[selectedIndex] ? options[selectedIndex].text : options[0].text}
            variant="primary"
            size="sm"
            isFullWidth
          />
        </div>
        <div className="button-split__button-menu">
          <Button
            ref={chevronRef}
            id={chevronId}
            ariaLabel={t('buttons:More options')}
            ariaControls={menuId}
            ariaExpanded={open}
            ariaHasPopup="menu"
            isDisabled={disabled}
            variant="primary"
            isIconOnly={true}
            leftIcon="chevron-down"
            size="sm"
            onClick={handleToggle}
            isFullWidth
          ></Button>
        </div>
      </fieldset>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal className="button-split__popper">
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id={menuId} autoFocusItem={open} aria-labelledby={chevronId} onKeyDown={handleListKeyDown}>
                  {optionsWithKeys.map(({ option, index, key }) =>
                    option.id !== 'separator' ? (
                      <MenuItem
                        key={key}
                        disabled={option.disabled}
                        selected={index === selectedIndex}
                        role="menuitemradio"
                        aria-checked={index === selectedIndex}
                        onClick={handleMenuItemClick(index)}
                      >
                        {option.icon && (
                          <div className="button-split__option-icon">
                            <Icon name={option.icon} size="md" />
                          </div>
                        )}
                        <span className="button-split__option-text">{option.text}</span>
                      </MenuItem>
                    ) : (
                      // `role="none"` deja el <li> fuera del árbol de accesibilidad (hijo
                      // HTML válido de <ul>) y expone el <hr> interior, que aporta el
                      // `role="separator"` nativo como hijo directo válido de role="menu".
                      <li className="button-split__separator" key={key} role="none">
                        <Hr />
                      </li>
                    )
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

ButtonSplit.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  options: PropTypes.array,
  selected: PropTypes.number,
};

export default ButtonSplit;
